import type { ApiError } from "@/Services/Api/Models";
import type { SubscriptionApi } from "@/Modules/Models/Api/Subscription";
import type { Subscription } from "@/Modules/Models/Domain/Subscription";

import { subscribeToB2bPlan } from "@/Services/TherapyApi/Subscriptions";

import useAppStore from "@/Modules/App/Store";
import useSubscriptionStore from "@/Modules/Subscription/Store";

import { ApiErrorCodes } from "@/Modules/App/Models/Api/ApiErrorCodes";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";
import camelize from "@/Utils/Camelize";

async function subscribeToB2bPlanAH(): Promise<Subscription | undefined> {
  const appStore = useAppStore();
  const subscriptionStore = useSubscriptionStore();

  subscriptionStore.isLoading = true;

  try {
    const subscriptionResponse = await subscribeToB2bPlan();
    const subscription = subscriptionApiToDomain(subscriptionResponse);
    subscriptionStore.subscription = subscription;

    return subscription;
  } catch (error) {
    const apiError = error as ApiError;
    const message = getErrorMessage(apiError.error_code);

    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message,
    });

    subscriptionStore.notification = {
      type: NotificationType.ERROR,
      code: apiError.error_code,
      message,
    };

    return undefined;
  } finally {
    subscriptionStore.isLoading = false;
  }
}

const getErrorMessage = (errorCode: ApiErrorCodes | string): string => {
  switch (errorCode) {
    case ApiErrorCodes.CHANGE_SUBSCRIPTION_ERROR:
    case ApiErrorCodes.CREATE_SUBSCRIPTION_ERROR:
      return "user.settings.subscription.payment.card_error.generic_decline";

    case ApiErrorCodes.INVALID_REDUCED_PLAN:
      return "there_was_an_error_connecting_to_the_server_please_try_again_later";

    default:
      return "user.settings.subscription.invalid_reduced_plan";
  }
};

const subscriptionApiToDomain = (subscriptionResponse: SubscriptionApi): Subscription => {
  return camelize<SubscriptionApi>(subscriptionResponse) as Subscription;
};

export default subscribeToB2bPlanAH;
